import MessageList from "../chat/MessageList";
import MessageComposeField from "../chat/MessageComposeField";
import React, {useContext, useState} from "react";
import AppContext from "../../context/AppContext";
import NotificationContext from "../../context/NotificationContext";
import {notifyWsFailure} from "../../lib/notifyWsFailure";
import {encryptMessage} from "../../lib/pgp";
import Sidebar from "../Sidebar";
import {useTranslation} from "react-i18next";

import './SidebarChat.scss'

export default () => {
  const {t} = useTranslation()

  const {
    ws,
    checkedIn,
    userData,
    keys,
    currentRoom,
    users, setUsers,
    typingUsers, setTypingUsers,
  } = useContext(AppContext)

  const { createNotification, hideNotification } = useContext(NotificationContext)

  const [ message, setMessage ] = useState<string>('')

  // RISKS.md/P2.15: the composer is cleared before the send, so a failed message is gone — hence
  // persistent, and a retry that re-sends the SAME ciphertext, which is all this function holds.
  const deliver = async (userMessages: { [uuid: string]: string }) => {
    try {
      await ws?.sendRoomMessage(currentRoom as string, userMessages)
    } catch (e) {
      console.error('sending the message failed', e)
      notifyWsFailure({ createNotification, hideNotification }, e, {
        id: 'chat-send-failed',
        message: t('chat.sendFailed'),
        persistent: true,
        actions: [{ label: t('lobby.retry'), onClick: () => { void deliver(userMessages) } }],
      })
    }
  }

  const send = async () => {
    if (!keys || !currentRoom) {
      return
    }

    const text = message
    setMessage('')

    const userMessages: { [uuid: string]: string } = {}
    try {
      for (const user of users) {
        if (user.pubKey) {
          userMessages[user.uuid] = await encryptMessage(text, user.pubKey)
        }
      }
    } catch (e) {
      // No retry here, unlike the send: `encryptMessage` fails on a roster public key, so the
      // same roster fails the same way.
      console.error('encrypting the message failed', e)
      notifyWsFailure({ createNotification, hideNotification }, e, {
        id: 'chat-send-failed',
        message: t('chat.sendFailed'),
        persistent: true,
      })
      return
    }

    await deliver(userMessages)
  }

  const onTyping = (typing: boolean) => {
    if (ws && currentRoom) {
      ws.sendRoomAction(currentRoom, 'typing', typing)
    }
  }

  return (
    <Sidebar type="chat" title={t('sidebar.chat.title')}>
      <div className="chat-area">
        {userData ? (
          <>
            <MessageList/>

            <MessageComposeField
              user={userData}
              users={users}
              value={message}
              onChange={e => setMessage(e.target.value)}
              onSubmit={send}
              onTyping={onTyping}
              typingUsers={typingUsers}
            />
          </>
        ) : null}
      </div>
    </Sidebar>
  )
}